<script setup lang="ts">
import { computed, useId } from 'vue';
import { classNames } from '@/js/lib/bem';

const props = withDefaults(
  defineProps<{
    name: string
    modelValue?: boolean
    disabled?: boolean
    invalid?: boolean
    required?: boolean
  }>(),
  {
    modelValue: false,
    disabled: false,
    invalid: false,
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>();

const inputId = useId();
const cn = classNames('base-checkbox');

const labelClasses = computed(() =>
  cn(props.invalid ? { state: 'invalid' } : undefined),
);
</script>

<template>
  <label :class="labelClasses" :for="inputId">
    <input
      :id="inputId"
      :name="name"
      class="base-checkbox__input"
      type="checkbox"
      :checked="modelValue"
      :disabled="disabled"
      :required="required"
      @change="
        emit('update:modelValue', ($event.target as HTMLInputElement).checked)
      "
    >
    <span class="base-checkbox__label">
      <slot />
    </span>
  </label>
</template>
